export default __webpack_public_path__ + "static/media/welcomeScreen.68ea2512.jpg";